import { ListItem, Text } from '@apollo/orbit';
import React from 'react';

interface Props {
  term: React.ReactNode;
  details: React.ReactNode;
}

export const DescriptionTermListItem = ({ term, details }: Props) => (
  <ListItem as="div">
    <Text as="dt" variant="bodySb">
      {term}:
    </Text>
    <Text as="dd">{details}</Text>
  </ListItem>
);
